
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.333 14.5v-12H4.667v12h6.666zM6 3.833h4v9.334H6V3.833zM4 5.167V3.833H1.333v9.334H4v-1.334H2.667V5.167H4zm8-1.334v1.334h1.333v6.666H12v1.334h2.667V3.833H12z","fill":"#2A333D"}})])
          )
        }
      }
    